/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';
import { useToast } from '../../../../context/ToastContext';

/*Import Requisição API*/
import api from '../../../../api';
import { converterDataParaYMD, validadorDataNascimento, formatadorCPF, formatadorCNPJ, removerCaracteresEspeciais } from '../../../../utils/Validadores';

export default function CadastroFuncionarios() {
    /* Variáveis auxiliares para dados */
    const navigate = useNavigate();
    const { showToast } = useToast();

    /* ID's */
    const [usuario_id, setIdUsuario] = useState();

    /* Variáveis de Dados do Funcionário */
    const [nome, setNome] = useState();
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [celular, setCelular] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [sexo, setSexo] = useState('');
    const [nivelAcesso, setNivelAcesso] = useState('');
    const [termosAceitos, setTermosAceitos] = useState(false);
    const [aceitoEnvioEmail, setAceitoEnvioEmail] = useState(false);

    /* Variáveis de Dados de Endereço do Funcionário */
    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);
    const [confSenha, setConfSenha] = useState('');
    const [senhasIguais, setSenhasIguais] = useState(null);
    const [forcaSenha, setForcaSenha] = useState(null);
    const senhaRef = useRef(null);
    const [mostrarBarra, setMostrarBarra] = useState(false);
    const [dataNascimentoValido, setDataNascimentoValido] = useState(null);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(prevState => !prevState);
    };

    // **Touched States**
    const [touchedNome, setTouchedNome] = useState(false);
    const [touchedCpf, setTouchedCpf] = useState(false);
    const [touchedEmail, setTouchedEmail] = useState(false);
    const [touchedSenha, setTouchedSenha] = useState(false);
    const [touchedCelular, setTouchedCelular] = useState(false);
    const [touchedData, setTouchedData] = useState(false);
    const [touchedSexo, setTouchedSexo] = useState(false);
    const [touchedNivel, setTouchedNivel] = useState(false);
    const [touchedCep, setTouchedCep] = useState(false);
    const [touchedNum, setTouchedNum] = useState(false);
    const [touchedComplemento, setTouchedComplemento] = useState(false);

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    /* Busca os dados do usuário */
    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    showToast('Erro ao carregar dados do usuário.', 'error');
                }
            } catch (error) {
                showToast('Erro ao buscar dados do usuário.', 'error');
            }
        };
        buscarDadosUsuario();
    }, []);

    /* Busca os endereço do funcionário */
    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) return;
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                showToast('CEP não encontrado.', 'error');
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            showToast('Erro ao buscar o endereço.', 'error');
        }
    };

    const mascaraCep = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/(\d{5})(\d{3})/, '$1-$2')
            .slice(0, 9);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'e') {
                e.preventDefault();
                setNome('Nome Padrão');
                setCpfCnpj('587.736.060-49');
                setCelular('(11) 91234-5678');
                setDataNascimento('04/08/2004');
                setSexo('masculino');
                setEmail('tuliofariasfracaro@hotmail.com');
                setSenha('SenhaForte123!');
                setNivelAcesso('Administrador');
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const forcaDaSenha = (senha) => {
        let strength = 0;
        if (senha.length >= 1) strength += 1;
        if (/[A-Z]/.test(senha)) strength += 1;
        if (/[0-9]/.test(senha)) strength += 1;
        if (/[^A-Za-z0-9]/.test(senha)) strength += 1;

        return strength < 4 ? 0 : strength;
    };

    const handleSenhaChange = (e) => {
        const valor = e.target.value;
        setSenha(valor);
        setMostrarBarra(valor.length > 0);
        setForcaSenha(forcaDaSenha(valor));
        if (confSenha !== '') {
            setSenhasIguais(valor === confSenha);
        } else {
            setSenhasIguais(null);
        }
    };

    const handleConfSenhaChange = (e) => {
        const valor = e.target.value;
        setConfSenha(valor);
        if (valor !== '') {
            setSenhasIguais(forcaSenha >= 4 && senha === valor);
        } else {
            setSenhasIguais(null);
        }
    };

    const enviarCadastroFuncionario = async (e) => {
        e.preventDefault();
        if (!nome || !cpfCnpj || !email || !senha || !celular || !dataNascimento || !sexo || !nivelAcesso || !cep || !logradouro || !numero || !bairro || !cidade || !estado) {
            showToast('Por favor, preencha todos os campos obrigatórios.', 'error');
            return;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);
        const dataNascimentoFormatada = converterDataParaYMD(dataNascimento);
        const funcionario = {
            nome,
            cpf_cnpj: removerCaracteresEspeciais(cpfCnpj),
            email,
            senha,
            celular,
            data_nascimento: dataNascimentoFormatada,
            sexo,
            nivel_acesso: nivelAcesso,
            termos_aceitos: termosAceitos,
            aceito_envio_email: aceitoEnvioEmail,
            endereco: {
                cep,
                logradouro,
                numero,
                complemento,
                bairro,
                cidade,
                estado
            }
        };

        try {
            const response = await api.post('/funcionarios', {
                funcionario,
                idAdministrador: usuario_id,
            });

            if (response.data.success) {
                showToast('Funcionário cadastrado com sucesso!', 'success');
                navigate('/menu/funcionarios');
            } else {
                showToast(response.data.message || 'Erro ao cadastrar funcionário.', 'error');
            }
        } catch (error) {
            showToast('Erro ao conectar com o servidor. Tente novamente.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleDataNascimentoChange = (e) => {
        let valor = e.target.value;

        valor = valor.replace(/\D/g, '');

        if (valor.length > 2 && valor.length <= 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2)}`;
        } else if (valor.length > 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2, 4)}/${valor.slice(4, 8)}`;
        }

        setDataNascimento(valor);

        if (valor.length === 10) {
            const ehValido = validadorDataNascimento(valor);
            setDataNascimentoValido(ehValido);
        }
    };

    const handleCpfOuCnpjChange = (e) => {
        const { value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');

        let valorFormatado = sanitizedValue;

        if (sanitizedValue.length <= 11) {
            valorFormatado = formatadorCPF(sanitizedValue);
        } else if (sanitizedValue.length <= 14) {
            valorFormatado = formatadorCNPJ(sanitizedValue);
        }

        setCpfCnpj(valorFormatado);
    };

    return (
        <section className='container-principal-cadastro-funcionario'>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />

            <main>
                <MenuLateral />

                <section className='conteudo-cadastro-funcionario'>

                    <div className='titulo-perfil'>
                        <h1><span>Funcionarios</span> &gt; Cadastro de funcionario</h1>
                    </div>

                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando dados do funcionário</h2>
                        </div>
                    ) : (
                        <div className='perfil-cadastro-funcionario'>
                            <h2>Digite os dados do funcionario</h2>
                            <form className='form-cadastro-funcionario' onSubmit={enviarCadastroFuncionario}>

                                <label className='lasbel-nome'>Nome: <span className='span-obrigatorio'>*</span></label>
                                <div className={`input-nome ${touchedNome && !nome ? 'invalido' : ''}`}>
                                    <input
                                        type="text"
                                        value={nome}
                                        onChange={(e) => setNome(e.target.value)}
                                        maxLength={255}
                                        placeholder="Digite o nome do funcionario"
                                    />
                                </div>

                                <label>CPF/CNPJ: <span className='span-obrigatorio'>*</span></label>
                                <div className={`input-CpfOuCnpj ${touchedCpf && !cpfCnpj ? 'invalido' : ''}`}>
                                    <input
                                        type="text"
                                        value={cpfCnpj}
                                        onChange={handleCpfOuCnpjChange}
                                        placeholder="Digite CPF ou CNPJ"
                                    />
                                </div>

                                <label>E-mail: <span className='span-obrigatorio'>*</span></label>
                                <div className={`input-email ${touchedEmail && !email ? 'invalido' : ''}`}>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Digite o e-mail"
                                    />
                                </div>

                                <label>Senha: <span className='span-obrigatorio'>*</span></label>
                                <div className={`input-senha ${touchedSenha && !senha ? 'invalido' : ''}`}>
                                    <input
                                        ref={senhaRef}
                                        id='senha'
                                        maxLength={255}
                                        placeholder='Digite a senha'
                                        type={passwordVisible ? 'text' : 'password'}
                                        value={senha}
                                        onChange={handleSenhaChange}
                                    />
                                    <button type='button' className='eyeButton' onClick={togglePasswordVisibility}>
                                        {passwordVisible ? <svg className='eye-icon' width='45' height='45' viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                            <path fill-rule='evenodd' clip-rule='evenodd' d='M22.5 37.125C33.5182 37.125 42.75 31.932 42.75 24.75C42.75 17.568 33.5182 12.375 22.5 12.375C11.4818 12.375 2.25 17.568 2.25 24.75C2.25 31.932 11.4818 37.125 22.5 37.125ZM22.5 16.875C31.365 16.875 38.25 20.7495 38.25 24.75C38.25 28.7505 31.365 32.625 22.5 32.625C13.635 32.625 6.75 28.7505 6.75 24.75C6.75 20.7495 13.635 16.875 22.5 16.875Z' />
                                            <path d='M20.2499 7.875C20.2499 7.27826 20.4869 6.70597 20.9089 6.28401C21.3309 5.86205 21.9032 5.625 22.4999 5.625C23.0966 5.625 23.6689 5.86205 24.0909 6.28401C24.5128 6.70597 24.7499 7.27826 24.7499 7.875V14.625C24.7499 15.2217 24.5128 15.794 24.0909 16.216C23.6689 16.6379 23.0966 16.875 22.4999 16.875C21.9032 16.875 21.3309 16.6379 20.9089 16.216C20.4869 15.794 20.2499 15.2217 20.2499 14.625V7.875ZM29.2949 8.559C29.4289 7.99127 29.7782 7.49778 30.269 7.18261C30.7599 6.86743 31.354 6.75521 31.926 6.86961C32.498 6.98401 33.0032 7.31609 33.3351 7.79581C33.6669 8.27553 33.7995 8.8654 33.7049 9.441L32.5799 15.066C32.4459 15.6337 32.0966 16.1272 31.6057 16.4424C31.1149 16.7576 30.5208 16.8698 29.9488 16.7554C29.3768 16.641 28.8716 16.3089 28.5397 15.8292C28.2078 15.3495 28.0752 14.7596 28.1699 14.184L29.2949 8.559ZM15.7049 8.559C15.5709 7.99127 15.2216 7.49778 14.7307 7.18261C14.2399 6.86743 13.6458 6.75521 13.0738 6.86961C12.5018 6.98401 11.9966 7.31609 11.6647 7.79581C11.3328 8.27553 11.2002 8.8654 11.2949 9.441L12.4199 15.066C12.5539 15.6337 12.9032 16.1272 13.394 16.4424C13.8849 16.7576 14.479 16.8698 15.051 16.7554C15.623 16.641 16.1282 16.3089 16.4601 15.8292C16.7919 15.3495 16.9245 14.7596 16.8299 14.184L15.7049 8.559ZM6.42814 11.2185C6.28077 10.9561 6.08226 10.7259 5.84435 10.5416C5.60643 10.3572 5.33396 10.2225 5.04305 10.1454C4.75214 10.0682 4.44871 10.0502 4.15072 10.0924C3.85273 10.1346 3.56623 10.2362 3.3082 10.3911C3.05016 10.546 2.82583 10.7511 2.64847 10.9943C2.47112 11.2375 2.34435 11.5137 2.27567 11.8068C2.20699 12.0998 2.1978 12.4036 2.24864 12.7002C2.29948 12.9969 2.40931 13.2803 2.57164 13.5337L5.94664 19.1588C6.09594 19.4177 6.29534 19.6443 6.53319 19.8253C6.77104 20.0063 7.04256 20.1381 7.33192 20.213C7.62127 20.2879 7.92265 20.3044 8.21846 20.2616C8.51426 20.2187 8.79856 20.1173 9.05475 19.9634C9.31095 19.8094 9.5339 19.606 9.71059 19.3649C9.88728 19.1238 10.0142 18.85 10.0838 18.5593C10.1535 18.2686 10.1646 17.967 10.1164 17.672C10.0682 17.377 9.96169 17.0946 9.80314 16.8413L6.42814 11.2185ZM38.5716 11.2185C38.8787 10.7068 39.3764 10.338 39.9553 10.1933C40.5342 10.0486 41.1469 10.1397 41.6586 10.4468C42.1703 10.7538 42.5391 11.2515 42.6839 11.8304C42.8286 12.4093 42.7374 13.022 42.4304 13.5337L39.0554 19.1588C38.7481 19.6708 38.2499 20.0397 37.6706 20.1844C37.0913 20.3292 36.4781 20.2378 35.9661 19.9305C35.4541 19.6232 35.0852 19.1251 34.9405 18.5457C34.7957 17.9664 34.8871 17.3533 35.1944 16.8413L38.5716 11.2185Z' />
                                            <path fill-rule='evenodd' clip-rule='evenodd' d='M22.5 31.5C24.5886 31.5 26.5916 30.6703 28.0685 29.1935C29.5453 27.7166 30.375 25.7136 30.375 23.625C30.375 21.5364 29.5453 19.5334 28.0685 18.0565C26.5916 16.5797 24.5886 15.75 22.5 15.75C20.4114 15.75 18.4084 16.5797 16.9315 18.0565C15.4547 19.5334 14.625 21.5364 14.625 23.625C14.625 25.7136 15.4547 27.7166 16.9315 29.1935C18.4084 30.6703 20.4114 31.5 22.5 31.5ZM22.5 20.25C23.3951 20.25 24.2536 20.6056 24.8865 21.2385C25.5194 21.8714 25.875 22.7299 25.875 23.625C25.875 24.5201 25.5194 25.3786 24.8865 26.0115C24.2536 26.6444 23.3951 27 22.5 27C21.6049 27 20.7464 26.6444 20.1135 26.0115C19.4806 25.3786 19.125 24.5201 19.125 23.625C19.125 22.7299 19.4806 21.8714 20.1135 21.2385C20.7464 20.6056 21.6049 20.25 22.5 20.25Z' />
                                        </svg> : <svg className='eye-icon' width='45' height='45' viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                            <path d='M41.2065 28.4766C41.345 28.7171 41.4347 28.9826 41.4706 29.2578C41.5066 29.533 41.4879 29.8126 41.4158 30.0806C41.3436 30.3487 41.2194 30.5998 41.0502 30.8199C40.8809 31.0399 40.67 31.2244 40.4295 31.3629C40.189 31.5014 39.9235 31.5912 39.6483 31.6271C39.3731 31.663 39.0935 31.6443 38.8254 31.5722C38.5574 31.5 38.3062 31.3758 38.0862 31.2066C37.8662 31.0374 37.6817 30.8265 37.5432 30.5859L34.5795 25.4004C32.9258 26.4407 31.1428 27.2598 29.2762 27.8367L30.2061 33.3984C30.2975 33.9502 30.1662 34.5156 29.8408 34.9705C29.5155 35.4254 29.0228 35.7325 28.4711 35.8242C28.3551 35.8449 28.2374 35.8549 28.1195 35.8541C27.6214 35.8536 27.1396 35.6768 26.7593 35.3551C26.379 35.0334 26.1248 34.5874 26.0418 34.0963L25.1365 28.6822C23.3806 28.8768 21.6085 28.8768 19.8526 28.6822L18.9561 34.1016C18.873 34.5933 18.6183 35.0397 18.2373 35.3615C17.8563 35.6833 17.3735 35.8597 16.8748 35.8594C16.757 35.8602 16.6393 35.8501 16.5233 35.8295C16.25 35.7835 15.9886 35.6841 15.7538 35.537C15.519 35.3899 15.3154 35.198 15.1548 34.9723C14.9942 34.7465 14.8796 34.4913 14.8176 34.2213C14.7556 33.9513 14.7475 33.6716 14.7936 33.3984L15.7235 27.8227C13.8568 27.2457 12.0739 26.4267 10.4201 25.3863L7.45646 30.5859C7.31796 30.8265 7.13344 31.0374 6.91343 31.2066C6.69342 31.3758 6.44223 31.5 6.17421 31.5722C5.90619 31.6443 5.62659 31.663 5.35136 31.6271C5.07613 31.5912 4.81067 31.5014 4.57014 31.3629C4.3296 31.2244 4.1187 31.0399 3.94948 30.8199C3.78026 30.5998 3.65603 30.3487 3.58388 30.0806C3.51173 29.8126 3.49308 29.533 3.529 29.2578C3.56491 28.9826 3.65468 28.7171 3.79318 28.4766L7.03107 22.8252C5.93378 21.834 4.91637 20.7578 3.9883 19.6066C3.66072 19.1697 3.51534 18.6228 3.58274 18.0809C3.65014 17.539 3.92508 17.0444 4.34971 16.701C4.77434 16.3577 5.31558 16.1924 5.85958 16.2399C6.40359 16.2874 6.90796 16.5441 7.26662 16.9559C10.0862 20.4469 15.0186 24.6094 22.4998 24.6094C29.9811 24.6094 34.9135 20.4469 37.733 16.9559C38.0859 16.5248 38.5949 16.2508 39.149 16.1937C39.7031 16.1366 40.2573 16.301 40.6907 16.651C41.124 17.0011 41.4013 17.5083 41.4621 18.062C41.5228 18.6157 41.362 19.171 41.0149 19.6066C40.0857 20.7579 39.0671 21.8341 37.9686 22.8252L41.2065 28.4766Z' />
                                        </svg>
                                        }
                                    </button>
                                </div>

                                <div className='senha-forca' style={{ display: senha.length > 0 ? 'flex' : 'none' }}>
                                    <div className='requisitos-senha'>
                                        <div className='condicao' style={{ color: senha.length >= 8 ? '#6cbe45' : '#cd3232' }}>
                                            {senha.length >= 8 ? (
                                                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#6cbe45' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path fill='#fff' fill-opacity='0' d='M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z' /><path d='M8 12l3 3l5 -5' /></g></svg>
                                            ) : (<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#cd3232' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path d='M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z' /><path d='M12 12l4 4M12 12l-4 -4M12 12l-4 4M12 12l4 -4' /></g></svg>
                                            )}  Mínimo de 8 caracteres
                                        </div>
                                        <div className='condicao' style={{ color: /[A-Z]/.test(senha) ? '#6cbe45' : '#cd3232' }}>
                                            {/[A-Z]/.test(senha) ? (
                                                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#6cbe45' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path fill='#fff' fill-opacity='0' d='M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z' /><path d='M8 12l3 3l5 -5' /></g></svg>
                                            ) : (<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#cd3232' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path d='M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z' /><path d='M12 12l4 4M12 12l-4 -4M12 12l-4 4M12 12l4 -4' /></g></svg>
                                            )} Letra maiúscula
                                        </div>
                                        <div className='condicao' style={{ color: /[0-9]/.test(senha) ? '#6cbe45' : '#cd3232' }}>
                                            {/[0-9]/.test(senha) ? (
                                                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#6cbe45' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path fill='#fff' fill-opacity='0' d='M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z' /><path d='M8 12l3 3l5 -5' /></g></svg>
                                            ) : (<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#cd3232' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path d='M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z' /><path d='M12 12l4 4M12 12l-4 -4M12 12l-4 4M12 12l4 -4' /></g></svg>
                                            )}  Número
                                        </div>
                                        <div className='condicao' style={{ color: /[^A-Za-z0-9]/.test(senha) ? '#6cbe45' : '#cd3232' }}>
                                            {/[^A-Za-z0-9]/.test(senha) ? (
                                                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#6cbe45' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path fill='#fff' fill-opacity='0' d='M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z' /><path d='M8 12l3 3l5 -5' /></g></svg>
                                            ) : (<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><g fill='none' stroke='#cd3232' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'><path d='M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z' /><path d='M12 12l4 4M12 12l-4 -4M12 12l-4 4M12 12l4 -4' /></g></svg>
                                            )}  Caractere especial
                                        </div>
                                    </div>
                                </div>

                                <label>Celular: <span className='span-obrigatorio'>*</span></label>
                                <div className={`input-celular ${touchedCelular && !celular ? 'invalido' : ''}`}>
                                    <input
                                        type="text"
                                        value={celular}
                                        onChange={(e) => setCelular(e.target.value)}
                                        placeholder="Digite o celular"
                                    />
                                </div>

                                <label>Data de Nascimento:</label>
                                <div className={`input-dataNascimento ${touchedData && !dataNascimento ? 'invalido' : ''}`}>
                                    <input
                                        type="text"
                                        value={dataNascimento}
                                        onChange={handleDataNascimentoChange}
                                        placeholder="DD/MM/AAAA"
                                        maxLength="10"
                                    />
                                </div>

                                <label>Sexo:</label>
                                <div className={`input-sexo ${touchedSexo && !sexo ? 'invalido' : ''}`}>
                                    <select value={sexo} onChange={(e) => setSexo(e.target.value)}>
                                        <option value="">Selecione</option>
                                        <option value="Masculino">Masculino</option>
                                        <option value="Feminino">Feminino</option>
                                        <option value="Outro">Outro</option>
                                    </select>
                                </div>

                                <label>Nível de Acesso:</label>
                                <div className={`input-nivelAcesso ${touchedNivel && !nivelAcesso ? 'invalido' : ''}`}>
                                    <select value={nivelAcesso} onChange={(e) => setNivelAcesso(e.target.value)}>
                                        <option value="" disabled>Selecione o nível de acesso</option>
                                        <option value="Administrador">Administrador</option>
                                        <option value="Entregador">Entregador</option>
                                        <option value="Separador">Separador</option>
                                        <option value="AssistenteAtendimento">Assistente de Atendimento</option>
                                        <option value="Financeiro">Financeiro</option>
                                    </select>
                                </div>

                                <div className='linha-1-endereco'>
                                    <div className='conteudo-cep'>
                                        <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                        <div className={`input-cep ${touchedCep && !cep ? 'invalido' : ''}`}>
                                            <input
                                                type="text"
                                                value={cep}
                                                onChange={(e) => setCep(mascaraCep(e.target.value))}
                                                onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                                maxLength={8}
                                                placeholder="Digite o CEP"
                                            />
                                        </div>
                                    </div>

                                    <div className='conteudo-numero'>
                                        <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                        <div className={`input-numero ${touchedNum && !numero ? 'invalido' : ''}`}>
                                            <input
                                                type="text"
                                                value={numero}
                                                onChange={(e) => setNumero(e.target.value)}
                                                placeholder="Digite o Nº"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <label>Logradouro:</label>
                                <div className='input-logradouro'>
                                    <input
                                        type="text"
                                        value={logradouro}
                                        onChange={(e) => setLogradouro(e.target.value)}
                                        placeholder="Logradouro"
                                        disabled
                                    />
                                </div>

                                <label>Bairro:</label>
                                <div className='input-bairro'>
                                    <input
                                        type="text"
                                        value={bairro}
                                        onChange={(e) => setBairro(e.target.value)}
                                        placeholder="Bairro"
                                        disabled
                                    />
                                </div>

                                <div className='linha-5-endereco'>
                                    <div className='conteudo-cidade'>
                                        <label className='lasbel-cidade'>Cidade:</label>
                                        <div className='input-cidade'>
                                            <input
                                                type="text"
                                                value={cidade}
                                                onChange={(e) => setCidade(e.target.value)}
                                                placeholder="Cidade"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className='conteudo-estado'>
                                        <label className='label-estado'>Estado:</label>
                                        <div className='input-estado'>
                                            <input
                                                type="text"
                                                value={estado}
                                                onChange={(e) => setEstado(e.target.value)}
                                                maxLength={2}
                                                placeholder="Estado"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <label>Complemento:</label>
                                <div className={`input-complemento ${touchedComplemento && !numero ? 'invalido' : ''}`}>
                                    <input
                                        type="text"
                                        value={complemento}
                                        onChange={(e) => setComplemento(e.target.value)}
                                        maxLength={255}
                                        placeholder="Digite o complemento (Opcional)"
                                    />
                                </div>

                                <button className='bnt-cadastro-funcionario' type="submit">Cadastrar Funcionario</button>
                            </form>
                        </div>
                    )}
                </section>
            </main >

            <Rodape />

        </section >
    );
}